import { FC } from 'react';
import { Helmet } from '@edikk-edikk/helmet';
import { useBaseContext } from '#base/hooks/use-base-context';

const GoogleSiteVerification: FC = () => {
  const { googleConfig } = useBaseContext();

  if (!googleConfig || !googleConfig.verificationId) {
    return null;
  }

  return (
    <Helmet>
      <meta name="google-site-verification" content={googleConfig.verificationId} />
    </Helmet>
  );
};

export { GoogleSiteVerification };
